module.exports = __webpack_public_path__ + "img/59-image001@2x.4e8ba5b2.png";